export const EpisodesLocalization = {
  ru: {
    more: 'Показать еще'
  },
  en: {
    more: 'Show more'
  }
}
